import { Component, OnInit } from '@angular/core';

import { CostCenter } from 'src/shared/models/cost-center.model';
import { CostCenterService } from 'src/shared/services/cost-center.service';

@Component({
  selector: 'smt-cost-center-select',
  templateUrl: './cost-center-select.component.html',
  styleUrls: ['./cost-center-select.component.scss']
})
export class CostCenterSelectComponent implements OnInit {
  public list: CostCenter[];
  public loading: boolean;
  
  constructor(
    public service: CostCenterService) { }

  ngOnInit() {
    this.loading = true;

    this.service.getAllActiveCostCenters().then((list: CostCenter[]) => {
      this.list = list;
      this.loading = false;
    });
  }

  routerLink() {
    return ['/workflow/planner/'];
  }

  queryParams(costCenterId: string) {
    return {
      costCenterId: costCenterId
    };
  }
}
